import { Flex } from '@chakra-ui/react';

import ButtonOutline from 'UiKit/button/buttonOutline';
import { EditIcon, TrashIcon } from 'Asset/icon';
import { getMenuPermissions } from 'Helper/getMenuPermissions';
import { Condition } from 'Component/others';

import useOpenDeleteModal from 'View/schedule-ruleset/hooks/useOpenDeleteModal';
import { useScheduleRulesetState } from 'View/schedule-ruleset/state';

const ActionButton = ({ values }) => {
  const accessPermission = getMenuPermissions('master-data', 'schedule-ruleset');
  const { onOpenDeleteModal } = useOpenDeleteModal();
  const { updateState } = useScheduleRulesetState();

  return (
    <Flex gap="10px">
      <Condition statement={accessPermission?.isCanEdit}>
        <ButtonOutline
          borderWidth="1.5px"
          width="34px"
          height="34px"
          onClick={() => updateState({ selectedRuleset: values, isOpenFormUpsert: true })}
          data-testid={`schedule-ruleset-edit-${values.id}`}
        >
          <EditIcon color="var(--color-info70)" />
        </ButtonOutline>
      </Condition>

      <Condition statement={accessPermission?.isCanDelete}>
        <ButtonOutline
          data-testid={`schedule-ruleset-delete-${values.id}`}
          borderWidth="1.5px"
          color="var(--color-error50)"
          width="34px"
          height="34px"
          onClick={() => onOpenDeleteModal(values?.id, values)}
        >
          <TrashIcon color="var(--color-error50)" />
        </ButtonOutline>
      </Condition>
    </Flex>
  );
};

export default ActionButton;
